import '../brochure.css'

import { useEffect, useRef, useState } from 'react'

import { Text } from '../../../Components'

export default function ParagrafiBrochure() {
  const [visibleBlocks, setVisibleBlocks] = useState(new Set())
  const blockRefs = useRef({})

  // Intersection Observer per animazioni scroll
  useEffect(() => {
    const observer = new window.IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const blockId = entry.target.dataset.blockId
            setVisibleBlocks((prev) => new Set([...prev, blockId]))
          }
        })
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }
    )

    // Osserva tutti i blocchi separati
    Object.values(blockRefs.current).forEach((ref) => {
      if (ref) observer.observe(ref)
    })

    return () => observer.disconnect()
  }, [])
  const paragraphs = [
    {
      title: 'Analisi intelligente delle richieste',
      text: 'NORA AI comprende e interpreta automaticamente le richieste di viaggio attraverso:\n• Elaborazione del linguaggio naturale\n• Riconoscimento di destinazioni e date\n• Identificazione delle preferenze del viaggiatore\n• Analisi del budget e dei vincoli aziendali\n• Integrazione con i sistemi HR e contabili'
    },
    {
      title: 'Ricerca e confronto automatico',
      text: 'Il sistema ricerca e confronta automaticamente le migliori opzioni disponibili:\n• Analisi di voli, hotel e trasporti in tempo reale\n• Confronto prezzi tra diversi fornitori\n• Valutazione di convenienza e qualità\n• Rispetto delle travel policy aziendali\n• Suggerimenti personalizzati basati sulla storia'
    },
    {
      title: 'Generazione preventivi intelligenti',
      text: 'NORA crea preventivi dettagliati e personalizzati includendo:\n• Calcolo automatico di tutti i costi\n• Breakdown dettagliato per categoria\n• Alternative economiche e premium\n• Conformità alle policy aziendali\n• Proiezioni di spesa e risparmio'
    },
    {
      title: 'Gestione approvazioni e prenotazioni',
      text: 'Il sistema gestisce automaticamente il flusso di approvazione e prenotazione:\n• Invio automatico per approvazione ai manager\n• Tracking dello stato delle richieste\n• Prenotazione automatica una volta approvata\n• Gestione delle modifiche e cancellazioni\n• Notifiche in tempo reale a tutti gli stakeholder'
    },
    {
      title: 'Monitoraggio e ottimizzazione continua',
      text: 'NORA monitora e ottimizza continuamente i viaggi:\n• Tracking dei costi in tempo reale\n• Analisi delle performance e dei risparmi\n• Suggerimenti per ottimizzazioni future\n• Reportistica automatica per il management\n• Apprendimento continuo dalle preferenze'
    },
    {
      separateBlock: true,
      title: 'Vantaggi chiave di NORA AI',
      text: "NORA AI rivoluziona la gestione dei viaggi d'affari attraverso:\n• Riduzione del 70% del tempo di gestione\n• Risparmio medio del 25% sui costi di viaggio\n• Automazione completa del processo\n• Conformità automatica alle policy aziendali\n• Esperienza utente superiore e intuitiva"
    },
    {
      separateBlock: true,
      title: '',
      text: "NORA AI rappresenta il futuro della gestione dei viaggi d'affari, combinando intelligenza artificiale avanzata con automazione completa per offrire un'esperienza di viaggio senza precedenti. La piattaforma garantisce efficienza operativa, risparmio sui costi e conformità totale, trasformando ogni viaggio d'affari in un'esperienza ottimizzata e senza stress."
    }
  ]

  // Separare i paragrafi normali da quelli con separateBlock
  const normalParagraphs = paragraphs.filter((p) => !p.separateBlock)
  const separateBlocks = paragraphs.filter((p) => p.separateBlock)

  return (
    <div className="brochure-process-container">
      {/* Header della sezione */}
      {/* <div className='brochure-section-header'>
        <Text
          value='Come funziona NORA'
          className='brochure-section-title'
        />
        <Text
          value="L'intelligenza artificiale nel settore dei viaggi d'affari presenta una serie di vantaggi considerevoli, contribuendo a semplificare e arricchire l'esperienza sia per i viaggiatori che per le aziende coinvolte."
          className='brochure-section-description'
        />
      </div> */}

      {/* Grid dei processi normali - Layout orizzontale */}
      <div className="brochure-steps-grid">
        {normalParagraphs.map((paragraph, index) => (
          <div key={index} className="brochure-step-card">
            {/* Numero del processo */}
            <div className="brochure-step-number">{index + 1}</div>

            <div className="brochure-step-content">
              <div className="brochure-step-header">
                <Text value={paragraph?.title || ''} className="brochure-step-title" />
              </div>
              {paragraph.text?.split('\n').map((value, index2) => (
                <Text key={index2} value={value || ''} className="brochure-step-text" />
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Blocchi separati - Layout a riga singola con animazioni scroll */}
      {separateBlocks.map((paragraph, index) => {
        const blockId = `separate-${index}`
        const isVisible = visibleBlocks.has(blockId)

        // Diversi tipi di animazione per variare l'effetto
        const animationType =
          index % 3 === 0 ? 'from-left' : index % 3 === 1 ? 'from-right' : 'scale'
        return (
          <div
            key={blockId}
            ref={(el) => {
              blockRefs.current[blockId] = el
            }}
            data-block-id={blockId}
            className={`brochure-separate-block animate-${animationType} ${isVisible ? 'animate-in' : ''}`}
          >
            <div className="brochure-separate-content">
              {paragraph.title && (
                <Text value={paragraph.title} className="brochure-separate-title" />
              )}
              {paragraph.text?.split('\n').map((value, index2) => (
                <Text key={index2} value={value || ''} className="brochure-separate-text" />
              ))}
            </div>
          </div>
        )
      })}
    </div>
  )
}
